import React from "react";
import { getPrivacyConsentNotice } from "../../../content/privacyConsentNotice";

const URL_PATTERN = /(https?:\/\/[^\s]+)/g;

const linkifyText = (text) => {
  const parts = [];
  let lastIndex = 0;
  let match;

  const regex = new RegExp(URL_PATTERN.source, URL_PATTERN.flags);
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(
      <a
        key={match.index}
        href={match[0]}
        target="_blank"
        rel="noopener noreferrer"
        className="privacy-consent-link"
      >
        {match[0]}
      </a>
    );
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length ? parts : text;
};

const PrivacyConsentContent = ({ lang, className = "", modal = false }) => {
  const notice = getPrivacyConsentNotice(lang);

  return (
    <div
      className={`consentDetailsText privacy-consent-content ${modal ? "privacy-consent-content--modal" : ""} ${className}`.trim()}
    >
      {notice.subtitle && (
        <p className="privacy-consent-subtitle text-muted small mb-2">{notice.subtitle}</p>
      )}
      {notice.blocks.map((block, index) => {
        if (block.type === "heading") {
          return (
            <h6 key={index} className="privacy-consent-heading mt-3 mb-2">
              {block.text}
            </h6>
          );
        }

        if (block.type === "list") {
          return (
            <ul
              key={index}
              className={`privacy-consent-list mb-2 ${block.listClass || ""}`.trim()}
            >
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex}>{item}</li>
              ))}
            </ul>
          );
        }

        return (
          <p
            key={index}
            className={`mb-2 ${block.emphasis ? "privacy-consent-confirmation fw-semibold" : ""}`}
          >
            {linkifyText(block.text)}
          </p>
        );
      })}
    </div>
  );
};

export default PrivacyConsentContent;
